import { Pagination } from '../../../models/pagination.model';
import { CourseItem } from '../course/models';
import { User } from '../users/models';

export enum OrderStatus {
  DRAFT = 'DRAFT',
  PENDING = 'PENDING', // payment pending
  AWAITING_APPROVAL = 'AWAITING_APPROVAL', // payment awaiting approval
  PARTIALLY_PAID = 'PARTIALLY_PAID', // installment payment in progress
  OVERDUE = 'OVERDUE', // installment past grace period
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
  REFUNDED = 'REFUNDED',
}

export interface PendingCourseOrder {
  status: 'AWAITING_APPROVAL' | 'PENDING' | 'OVERDUE';
  orderId?: string;
  course?: CourseItem;
  dueDate?: Date;
  gracePeriodEnd?: Date;
  installmentNumber?: number;
  amount?: number;
}

export enum PaymentOptions {
  BANK_TRANSFER = 'BANK_TRANSFER',
  PAYHERE = 'PAYHERE',
}

export interface Billing {
  name: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  province: string;
  postalCode: string;
  contactNumber: string;
  country: string;
}

export interface Payment {
  id?: string;
  initiatedOn?: Date; // Track when user initiated the payment
  approvedOn?: Date; // when payment is manually approved by user
  isApproved?: boolean;
  modeOfPayment: PaymentOptions;
  billingInformation: Billing | undefined;
  amount?: number;
  currencyCode?: string;
  ipgData?: unknown;
  bankData?: any;
}

export interface OrderInstallment {
  installmentNumber: number;
  amount: number;
  dueDate: Date;
  status: 'PENDING' | 'PAID' | 'OVERDUE';
  paidOn?: Date;
}

export interface CreateOrderDTO {
  items: string[];
  paymentPlan?: 'FULL' | 'INSTALLMENT';
  currency?: string;
  totalAmount?: number;
}

export interface Order {
  _id?: string;
  orderId?: string;
  createdOn?: Date;
  user?: User | string;
  items: CourseItem[];
  status?: OrderStatus;
  totalAmount?: number;
  paidAmount?: number;
  remainingAmount?: number;
  currency?: string;
  paymentPlan?: 'FULL' | 'INSTALLMENT';
  currentInstallment?: number;
  installments?: OrderInstallment[];
  payment?: Payment;
}

export interface OrderResponse extends Pagination {
  docs: Order[];
}
